import { useState } from 'react';
import { ScrollView } from 'react-native';
import { VStack } from '../../src/components/primitives/Stack';
import { TAB_ROUTE_BY_HREF } from '../../src/config/navigation';
import { useEdgeToEdge } from '../../src/contexts/LayoutChromeContext';
import { useTranslation } from '../../src/contexts/TranslationContext';
import {
  AnalyticsHeader,
  type AnalyticsTabKey,
  AnalyticsTabs,
  CampaignsTab,
  FunnelTab,
  OverviewTab,
  TeamTab,
  type TimeRange,
} from '../../src/features/analytics';
import { useTabNavResetKey } from '../../src/hooks/useTabNavResetKey';
import { tokens } from '../../src/theme/tokens';

export default function AnalyticsScreen() {
  const { t } = useTranslation();
  const [timeRange, setTimeRange] = useState<TimeRange>('30d');
  const [activeTab, setActiveTab] = useState<AnalyticsTabKey>('overview');

  // Fill the available space like chat/voice-agents/dashboard (no
  // DashboardLayout padding frame); the ScrollView carries its own inset.
  useEdgeToEdge();

  // Remount the scroll view on each chrome navigation so returning to Analytics
  // lands at the top (FLOSEAI-416).
  const scrollResetKey = useTabNavResetKey(TAB_ROUTE_BY_HREF['/analytics']);

  return (
    <ScrollView
      key={`analytics-${scrollResetKey}`}
      style={{ flex: 1 }}
      contentContainerStyle={{
        paddingHorizontal: tokens.spacing.lg,
        paddingTop: tokens.spacing.lg,
        paddingBottom: tokens.spacing['4xl'],
      }}
      showsVerticalScrollIndicator={false}
    >
      <VStack testID="analytics_screen" spacing="lg">
        <AnalyticsHeader
          title={t('analytics.screen.title')}
          subtitle={t('analytics.screen.subtitle')}
          timeRange={timeRange}
          onTimeRangeChange={setTimeRange}
        />

        <AnalyticsTabs activeTab={activeTab} onTabChange={setActiveTab} />

        {activeTab === 'overview' && <OverviewTab timeRange={timeRange} />}
        {activeTab === 'funnel' && <FunnelTab timeRange={timeRange} />}
        {activeTab === 'campaigns' && <CampaignsTab timeRange={timeRange} />}
        {activeTab === 'team' && <TeamTab timeRange={timeRange} />}
      </VStack>
    </ScrollView>
  );
}
